export default __webpack_public_path__ + "static/wallAndFloor-f3f03dc62d8d492007eab945347ea005.jpeg";